import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import TitleBar from '../kiosk/components/TitleBar'
import ItemButton from '../components/ItemButton'
import Menu from '../components/Menu'
import FunctionBar from '../components/FunctionBar'
import { setCurrentObjectGroup, setSelectedObjectItem } from '../objectmanagement/actions/objectManagementActions'
import { continueObjectManagementOpen } from '../kiosk/actions/kioskActions'
import { getTranslation } from '../actions/dataActions'
import * as types from '../constants/Types'
import * as resource from '../constants/Resources'
import { checkReceiptTimeout, checkCloseTimeout } from '../actions/receiptActions.js'
import Receipt from '../kiosk/components/Receipt'
import ReceiptItem from '../freeformat/components/ReceiptItem'
import OpenOrdersOverview from '../freeformat/components/OpenOrdersOverview'
import * as general from '../constants/General'
import TicketScannerButton from '../freeformat/components/TicketScannerButton'
import SelectPagerButton from '../freeformat/components/SelectPagerButton'
import ArticlePrice from '../freeformat/components/ArticlePrice'

class KioskPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timerid: null,
      isOpen: false,
      closeinterval: null,
      timeout: new Date()
    };

    this.renderKeylayout = this.renderKeylayout.bind(this);
    this.renderNewOrderComponent = this.renderNewOrderComponent.bind(this);
    this.renderItemButtonComponents = this.renderItemButtonComponents.bind(this);

    this.getSessionTimeout = this.getSessionTimeout.bind(this);
    this.getClosingTimeout = this.getClosingTimeout.bind(this);
    this.cancelTimer = this.cancelTimer.bind(this);
    this.resetTimeout = this.resetTimeout.bind(this);
  }

  componentDidMount() {
    this.getSessionTimeout();
    this.getClosingTimeout();
    this.resetTimeout();
  }

  componentWillUnmount() {
    this.cancelTimer();
  }

  cancelTimer() {
    const {
      timerid,
    } = this.state;

    if (timerid !== null) {
      clearInterval(timerid);
      this.setState({ timerid: null });
    }
  }

  getSessionTimeout() {
    const {
      checkReceiptTimeout,
      posType,
    } = this.props;
    //Na x aantal seconden bon stoppen
    if (this.state.timerid === null && posType === types.POSTYPE_SALESKIOSK && this.props.receiptnumber !== null && this.props.receiptnumber >= 0) {
      this.setState({ timeout: new Date() });
      const newTimerid = setInterval(() => {
        if (this.props.receiptnumber !== null && this.props.receiptnumber >= 0) {
          checkReceiptTimeout(this.state.timeout);
        }
        else {
          this.cancelTimer();
        }
      }, 1000);

      this.setState({ timerid: newTimerid });
    }
  }

  getClosingTimeout() {
    const {
      posType,
      openingTime,
      closingTime,
      checkCloseTimeout
    } = this.props;
    if (posType === types.POSTYPE_SALESKIOSK && openingTime !== null && closingTime !== null) {
      const newCloseInterval = setInterval(() => {
        checkCloseTimeout(openingTime, closingTime);
      }, 1000);

      this.setState({ closeinterval: newCloseInterval });
    }
  }

  componentDidUpdate() {
    //Na x aantal seconden bon stoppen
    this.getSessionTimeout();
  }

  resetTimeout() {
    this.setState({ timeout: new Date() });
  }

  renderKeylayout() {
    const {
      posType,
      displayMode,
      receiptnumber,
      selectedObjectItemId
    } = this.props;

    if (selectedObjectItemId > 0 || (posType === types.POSTYPE_SALESKIOSK && receiptnumber !== null && receiptnumber >= 0) || displayMode === types.DISPLAYMODE_FREEFORMAT) {
      return this.renderItemButtonComponents();
    } else {
      return this.renderNewOrderComponent();
    }
  }

  renderNewOrderComponent() {
    const newOrderBtn = { key: 1, id: 1, text: this.props.getTranslation(resource.BUTTON_NEW_ORDER), color: "#475358", btnwidth: 90, btnheight: 90, btntop: 4, btnleft: 4, itemtype: types.BUTTON_KIOSK };
    return (
      <ItemButton key={newOrderBtn.key} id={newOrderBtn.id} text={newOrderBtn.text} color={newOrderBtn.color} btnwidth={newOrderBtn.btnwidth}
        btnheight={newOrderBtn.btnheight} btntop={newOrderBtn.btntop} btnleft={newOrderBtn.btnleft} itemtype={newOrderBtn.itemtype} />
    )
  }

  renderItemButtonComponents() {
    const {
      groups,
      groupId,
      displayMode
    } = this.props;

    let rasterx = 6
    let rastery = 6
    let keys = [];

    const item = groups.find(grp => grp.KeyLayoutGroupId === groupId);
    rasterx = item.RasterX;
    rastery = item.RasterY;
    keys = item.KeyLayoutItems;

    const datagrid = {
      x: rasterx,
      y: rastery
    }

    const defaultbtnwidth = 100.0 / datagrid.x
    const defaultbtnheight = 100.0 / datagrid.y
    const drawbtns = []

    keys.map(key => {
      const btntop = key.PositioningMode === 200 ? key.LocationY / 10 : (defaultbtnheight * (key.LocationY + 1)) - defaultbtnheight
      const btnleft = key.PositioningMode === 200 ? key.LocationX / 10 : (defaultbtnwidth * (key.LocationX + 1)) - defaultbtnwidth
      const btnwidth = key.PositioningMode === 200 ? key.Width / 10 : defaultbtnwidth * key.Width
      const btnheight = key.PositioningMode === 200 ? key.Height / 10 : defaultbtnheight * key.Height

      drawbtns.push({
        id: key.KeyLayoutItemId,
        itemvalue: key.ItemValue,
        itemtype: key.ItemType,
        itemparam: key.ItemParam,
        description: key.Description,
        color: key.Color,
        width: btnwidth,
        height: btnheight,
        top: btntop,
        left: btnleft,
        invisible: key.Invisible,
        fileAttachmentId: key.FileAttachmentId
      })
      return ''
    });

    return (
      drawbtns.map(btn => {
        switch (btn.itemtype) {
          case types.BUTTON_OTHER:
            return <ReceiptItem
              key={btn.id}
              id={btn.id}
              width={btn.width}
              height={btn.height}
              top={btn.top}
              left={btn.left}
              itemvalue={btn.itemvalue}
            />
          case types.BUTTON_FUNCTION:
            switch (btn.itemvalue) {
              case '310':
                return <OpenOrdersOverview
                  key={btn.id}
                  id={btn.id}
                  width={btn.width}
                  height={btn.height}
                  top={btn.top}
                  left={btn.left}
                  itemvalue={btn.itemvalue}
                  itemparam={btn.itemparam}
                />
              case '320':
                return <TicketScannerButton
                  key={btn.id}
                  id={btn.id}
                  width={btn.width}
                  height={btn.height}
                  top={btn.top}
                  left={btn.left}
                />
              case '370':
                return <SelectPagerButton
                  key={btn.id}
                  id={btn.id}
                  width={btn.width}
                  height={btn.height}
                  top={btn.top}
                  left={btn.left}
                />
              case '380':
                return <ArticlePrice
                  key={btn.id}
                  width={btn.width}
                  height={btn.height}
                  top={btn.top}
                  left={btn.left}
                  itemparam={btn.itemparam}
                  fileAttachmentId={btn.fileAttachmentId}
                />
              default:
                return <ItemButton
                  key={btn.id}
                  id={btn.id}
                  itemvalue={btn.itemvalue}
                  itemtype={btn.itemtype}
                  itemparam={btn.itemparam}
                  text={btn.description}
                  color={btn.color}
                  btnwidth={btn.width}
                  btnheight={btn.height}
                  btntop={btn.top}
                  btnleft={btn.left}
                  price={btn.price}
                  configurationsteps={btn.configurationsteps}
                  invisible={btn.invisible}
                  displayMode={displayMode}
                  fileAttachmentId={btn.fileAttachmentId}
                />
            }
          default:
            return <ItemButton
              key={btn.id}
              id={btn.id}
              itemvalue={btn.itemvalue}
              itemtype={btn.itemtype}
              itemparam={btn.itemparam}
              text={btn.description}
              color={btn.color}
              btnwidth={btn.width}
              btnheight={btn.height}
              btntop={btn.top}
              btnleft={btn.left}
              price={btn.price}
              configurationsteps={btn.configurationsteps}
              invisible={btn.invisible}
              displayMode={displayMode}
              fileAttachmentId={btn.fileAttachmentId}
            />
        }
      })
    );
  }

  render() {
    const {
      displayMode,
      groups,
      groupId
    } = this.props;

    const item = groups.find(grp => grp.KeyLayoutGroupId === groupId);
    const style = {
      backgroundImage: item && item.FileAttachmentId > 0 ? `url('${general.API_URL_BUTTON_IMAGE}/${item.FileAttachmentId}')` : '',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      overflow: 'hidden'
    };

    if (displayMode !== types.DISPLAYMODE_FREEFORMAT) {
      return (
        <div id="app" onClick={this.resetTimeout}>
          <div id="main-container" style={style}>
            <TitleBar />
            <div id="overview">
              <div id="items">
                {this.renderKeylayout()}
              </div>
            </div>
            <Menu />
            <FunctionBar cssClass="ov_functionbar" />
          </div>
          <div id="receipt-keyboard-container">
            <Receipt />
          </div>
        </div>
      )
    }
    else {
      // positioning of items div is tweaked here in order to match positioning in preview in backoffice
      return (
        <div id="overview" onClick={this.resetTimeout} style={style}>
          <div id="items" style={{ border: "0px", padding: "0px", overflow: "hidden", left: "-3px", top: "-7px", bottom: "-7px", right: '-2px' }}>
            {this.renderKeylayout()}
          </div>
        </div>
      )
    }
  }
}

KioskPage.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({
    KeyLayoutGroupId: PropTypes.number.isRequired
  })).isRequired,
  groupId: PropTypes.number.isRequired,
  getTranslation: PropTypes.func
}

function mapStateToProps(state) {
  return {
    groups: state.layoutState.groups.items,
    groupId: state.layoutState.groupid,
    isLoading: state.generalState.isLoading,
    objectgroups: state.objectManagementState.objectgroups,
    general: state.generalState,
    currentPosId: state.generalState.posId,
    openingTime: state.generalState.openingTime,
    closingTime: state.generalState.closingTime,
    selectedObjectGroupId: state.objectManagementState.selectedobjectgroup,
    selectedObjectItemId: state.receiptState.receipt.objectitemid,
    posType: state.generalState.posType,
    receiptnumber: state.receiptState.receipt.receiptnumber,
    displayMode: state.generalState.displayMode,
    closepage: state.layoutState.closepage,
    defaultpage: state.layoutState.defaultpage
  }
}

export default connect(mapStateToProps,
  {
    setCurrentObjectGroup,
    setSelectedObjectItem,
    continueObjectManagementOpen,
    getTranslation,
    checkReceiptTimeout,
    checkCloseTimeout,
  })(KioskPage)



// WEBPACK FOOTER //
// src/pages/KioskPage.jsx